import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { ModalsProvider } from "@mantine/modals";
import { MantineProvider } from "@mantine/core";
import { NotificationsProvider } from "@mantine/notifications";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <MantineProvider>
    <NotificationsProvider position="top-right" zIndex={2077}>
      <ModalsProvider>
        <App />
      </ModalsProvider>
    </NotificationsProvider>
  </MantineProvider>
);
